import React, { useState } from 'react';
import { Table, Button, Typography, Input } from 'antd';

const { Title } = Typography;

export const ResumenStep = ({ selectedItems, handleFinish, loading = false }) => {
  const [observaciones, setObservaciones] = useState('');

  const columns = [
    { title: 'Artículo', dataIndex: 'nombreArticulo', key: 'nombreArticulo' },
    {
      title: 'Posiciones / Lotes a Retirar',
      render: (_, record) => (
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {(record.posiciones || []).map((p, idx) => (
            <li key={`${p.posicion}-${idx}`}>
              <strong>{p.posicion}</strong>
              <ul style={{ marginTop: 4 }}>
                {(p.lotes || []).map((l, j) => (
                  <li key={`${p.posicion}-l-${j}`}>
                    Lote: {l.lote || '—'} · Venc.: {l.fechaVencimiento ? new Date(l.fechaVencimiento).toISOString().slice(0,10) : '—'} · Retirar: {Number(l.cantidadRetirar).toFixed(2)}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      ),
    },
  ];

  return (
    <>
      <Title level={4}>Resumen de Movimientos</Title>
      <Input.TextArea
        placeholder="Ingrese observaciones"
        value={observaciones}
        onChange={(e) => setObservaciones(e.target.value)}
        rows={3}
        style={{ marginBottom: 16 }}
      />
      <Table
        dataSource={selectedItems}
        columns={columns}
        rowKey={(r) => r?.articulo?._id || r?.nombreArticulo}
        pagination={{ pageSize: 5 }}
      />
      <Button
        type="primary"
        onClick={() => handleFinish(observaciones)}
        loading={loading}
        disabled={loading}
        style={{ marginTop: 16 }}
      >
        Confirmar Movimientos
      </Button>
    </>
  );
};